
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.465 1.25h9.071a4.228 4.228 0 014.214 4.214l-.75.003.75.002a4.227 4.227 0 01-4.214 4.214l-.003-.75v.75H5.465A4.226 4.226 0 011.25 5.47L2 5.467l-.75-.002A4.227 4.227 0 015.465 1.25zM2.75 5.467a2.726 2.726 0 002.718 2.716h9.064a2.727 2.727 0 002.718-2.716 2.728 2.728 0 00-2.718-2.717H5.468A2.727 2.727 0 002.75 5.467zm2.715 4.849h9.071a4.227 4.227 0 014.214 4.215l-.75.002.75.002a4.227 4.227 0 01-4.214 4.215l-.003-.75v.75H5.465a4.225 4.225 0 01-4.215-4.215l.75-.002-.75-.002a4.227 4.227 0 014.215-4.215zM2.75 14.533a2.726 2.726 0 002.718 2.717h9.064a2.726 2.726 0 002.718-2.717 2.728 2.728 0 00-2.718-2.717H5.468a2.727 2.727 0 00-2.718 2.717z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.67 3.54a2.083 2.083 0 111.594 3.85 2.083 2.083 0 01-1.595-3.85zm.797 1.342a.583.583 0 100 1.166.583.583 0 000-1.166zm7.593 8.181a2.083 2.083 0 112.947 2.947 2.083 2.083 0 01-2.947-2.947zm1.473.89a.583.583 0 100 1.166.583.583 0 000-1.166z","clip-rule":"evenodd"}})])
          )
        }
      }
    